<template>
  <b-modal
    id="create-delete-reason-modal"
    title="Create Delete Reason"
    hide-footer
    size="lg"
    no-close-on-backdrop
    @hidden="formData = FORM_SNAPSHOT()"
  >
    <b-form
      novalidate
      @submit.prevent="submitForm"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Reason En"
              rules="required"
            >
              <b-form-group
                label="Reason En"
                label-for="reason-name-en"
              >
                <b-form-input
                  id="reason-name-en"
                  v-model="formData.reason.en"
                  placeholder="Reason En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Reason Ar"
              rules="required"
            >
              <b-form-group
                label="Reason Ar"
                label-for="reason-name-ar"
              >
                <b-form-input
                  id="reason-name-ar"
                  v-model="formData.reason.ar"
                  placeholder="Reason Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <b-button
              type="submit"
              variant="primary"
              :disabled="submitting"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BRow,
  BCol,
  BModal,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

const FORM_SNAPSHOT = () => JSON.parse(JSON.stringify({
  reason: {
    ar: null,
    en: null,
  },
}))

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BSpinner,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  setup(props, ctx) {
    const submitting = ref(false)

    const formData = ref(FORM_SNAPSHOT())

    const formRef = ref(null)

    const submitForm = async () => {
      const res = await formRef.value.validate()
      if (!res) return

      try {
        submitting.value = true
        await axiosIns.post('/teams/delete-reasons', formData.value)
        ctx.root.$bvModal.hide('create-delete-reason-modal')
        ctx.emit('refetch')
      } catch (err) {
        console.log(err?.response)
        errorNotification('An Error Occured')
      } finally {
        submitting.value = false
      }
    }

    return {
      submitting,
      formRef,
      submitForm,
      formData,
      FORM_SNAPSHOT,
      required,
    }
  },
}
</script>

      <style></style>
